<template>
  <section class="panel--people" aria-label="people panel">
      <section class="panel panel--content panel--tab-header" id="people-panel" v-show="!group_labels == 1">
		<div class="panel__body">
			<ul class="tabs__list" role="tablist">
                <li v-for="group in groups" :key="group.term_id" class="tabs__item">
                    <button :class="active_group.slug == group.slug ? 'tabs__link is-active' : 'tabs__link'" @click="set_active_group(group.slug)">{{ group.name }}</button>
				</li>
			</ul>
		</div>
	</section>
    <section class="panel panel--content panel--secondary panel--article-body panel--tabs is-display" style="margin-bottom:0;">
        <div  class="panel__body">
            <div class="filter">
                <transition name="fade">
                    <div v-if="sub_groups.length > 0" class="filter__categories">
                        <div class="filter__select">
                            <select v-if="sub_groups.length" v-model="selected" class="custom-select group-search form-control show-dropdown" aria-label="subcategories">
                                <option value="" selected>All subcategories</option>
                                <option v-for="sub_group in sub_groups" :key="sub_group.slug" :value="sub_group.slug">{{ sub_group.name }}</option>
                            </select>
                        </div>
                    </div>
                </transition>
                <div v-if="!filters" class="filter__input">
                    <div class="filter__box">
                        <input id="people-search-by-keyword" class="form-control" type="text" placeholder="Filter people by keyword" aria-label="filter people" v-model="search" v-debounce:500ms="search_people">
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <section v-if="!filtering" class="panel panel--content panel--spaced panel--tight panel--secondary">
                <div class="panel__body">
                    <h2 class="sr-only">{{ active_group.name }}</h2>
                    <div class="content content--card quickspot-inline-results-container" style="display: block;">
                        <ul>
                        <template v-for="person in filtered_list">
                            <card :data="person" :key="person.id"></card>
                        </template>
                        </ul>
                    </div>
                </div>
            </section>
        </transition>
    </section>
  </section>
</template>

<script>
import Card from './card.vue'
import mixins from '../mixins.js'

export default {
    components: {
        'card': Card,
    },
    props: {
        people: Array,
        groups: Array,
        group_labels: Boolean,
        filters: Boolean,
        orderby: String,
        order: String
    },
    mixins: [ mixins ],
    data() {
        return {
            active_group: {
                name: '',
                slug: '',
                term_id: '',
            },
            sub_groups: [],
            selected: '',
            active_sub_group: {
                name: '',
                slug: '',
                term_id: '',
            },
            search: '',
            filtered_list: [],
            filtered_list_lc: [],
            filtering: false
        }
    },
    watch: {
        selected() {
            if(this.selected == '') {
                this.clear_active_sub_group();
            } else {
                this.set_active_sub_group();
            }
        }
    },
    methods: {
        check_for_group_parameter_in_url() {
            // Check if a category is set in the url by splitting it down and getting the last string value
            let current_url = window.location.href;
            let split_url = current_url.split('/');
            let last_string = split_url[split_url.length - 1];

            // Check if it is a hash value at the start
            if(last_string != undefined && last_string.charAt(0) == '#') {
                // Loop through the groups and find a corresponding group
                for (var i = 0; i < this.groups.length; i++) {
                    if('#' + this.groups[i].slug == last_string) {
                        // If a match is found set it as the active group
                        this.active_group.name = this.groups[i].name;
                        this.active_group.slug = this.groups[i].slug;
                    }
                }
                if(this.active_group.name != '' && this.filtering == false){
                    this.set_inital_group();
                    this.filter_people();
                }
            } else {
                this.set_inital_group();
            }
        },
        clean_groups() {
            // One time only function to clean groups
            
            // This fix resolves an issue on research.kent where the groups data was being returned as an object of objects and not an array
            // We now check to see if it is an object and it is, then reprocess it into an array
            let isArr = Object.prototype.toString.call(this.groups) == '[object Array]';
            if(!isArr) {
                var result = Object.entries(this.groups).map(e => e[1])
                this.groups = result
            }
            // Now we can loop through the groups array and clean up the data
            for(let i = 0; i < this.groups.length; i++) {
                // Remove any unencided ampersand symbols from the top level group name
                this.groups[i].name = this.groups[i].name.replace("&amp;","&");
                // Then check if it has children / sub group
                if(this.groups[i].children.length > 0) {
                    // Loop though these and clean these up also
                    for (var j = 0; j < this.groups[i].children.length; j++) {
                        this.groups[i].children[j].name = this.groups[i].children[j].name.replace("&amp;","&");
                        this.groups[i].children[j].slug = this.groups[i].children[j].slug.replace("&amp;","&");
                    }
                }
            }
        },
        clean_profiles() {
            // One time only function to clean the profiles before filtering

            // Loop through the people array
            for (var i = 0; i < this.people.length; i++) {
                // Reset the person to not show
                this.people[i].show = false;
                // Then for each person loop through their categories
                for (var j = 0; j < this.people[i].categories.length; j++) {
                    // Update the categories within each profile
                    this.people[i].categories[j].name = this.people[i].categories[j].name.replace("&amp;","&");
                }
                // Added in an if check to stop the panel erroring on load
                if(this.people[i].role !== null) {
                    this.people[i].role = this.people[i].role.replace("&amp;","&");
                }
            }
        },
        clear_active_sub_group() {
            this.active_sub_group.name = '';
            this.active_sub_group.slug = '';
            this.active_sub_group.term_id = '';

            // Now filter the people based on this
            this.filter_people();
        },
        extractNames(person) {
            var names = [];
            if(person.name != undefined || person.name != '') {
                var fullname = person.name;
                names.push(fullname.split(' ').slice(0, -1).join(' ')); // firstname
                names.push(fullname.split(' ').slice(-1).join(' ')); // lastname
            }
            return names;
        },
        filter_people() {
            this.filtering = true;
            this.search = '';
            this.filtered_list = [];
            this.filtered_list_lc = [];

            // Loop through the people array
            for (var i = 0; i < this.people.length; i++) {
                // Reset the person to not show
                this.people[i].show = false;
                // Then for each person loop through their categories
                for (var j = 0; j < this.people[i].categories.length; j++) {
                    // Check for a match
                    if(this.people[i].categories[j].term_id == this.active_group.term_id) {
                        // Now, if an active sub group is present then check against the persons sub groups
                        if(this.active_sub_group.name.length > 0) {
                            // Then for each person loop through their categories
                            if (this.people[i].categories.some(e => e.name == this.active_sub_group.name)) {
                                this.filtered_list.push(this.people[i]);
                            } 
                        } else {
                            // Else just show
                            this.filtered_list.push(this.people[i]);
                        }
                    }
                }
            }
            setTimeout(() => {
                this.filtering = false;
            }, 250);
        },
        order_data() {
            var self = this;
            let orderby = this.orderby;
            let order = this.order;
            this.people.sort(compare);

            function compare(a, b) {
                // If the specified ordering key is blank set it to use date instead
                if(b[orderby] == undefined) {
                    orderby = 'date';
                }
                // If no firstname or lastname set, attempt to extract from persons fullname
                var names;
                if(b[orderby].length < 1) {
                    switch(orderby) {
                        case 'firstname' : {
                            names = self.extractNames(b);
                            if(names.length > 0) {
                                b[orderby] = names[0];
                            }
                        }
                        break;
                        case 'lastname' : {
                            names = self.extractNames(b);
                            if(names.length > 0) {
                                b[orderby] = names[1];
                            }
                        }
                    }
                }

                // Use toUpperCase() to ignore character casing
                const personA = a[orderby].toUpperCase();
                const personB = b[orderby].toUpperCase();
                // Sort the data
                let comparison = 0;
                if (personA > personB) {
                    comparison = 1;
                } else if (personA < personB) {
                    comparison = -1;
                }
                // Defines the order of the sorted people
                if(order == 'ASC') {
                    return comparison;
                } else {
                    return comparison * -1;
                }
            }
        },
        search_people() {
            this.filtering = true;

            var results = [];

            this.search = this.trim_string(this.search);
            let search_term = this.search.toUpperCase();

            if(this.search.length > 0){

                for(var i = 0; i < this.filtered_list.length; i++) {
                    for(var key in this.filtered_list[i]) {
                        let value = this.filtered_list[i][key];
                        // Need to loop through the keys rather than specifying them
                        if(typeof value === 'string') {
                            if(value.toUpperCase().indexOf(search_term) !== -1) {
                                if(!this.item_exists(results, this.filtered_list[i])) {
                                    results.push(this.filtered_list[i])
                                }
                            } 
                        }
                    }
                }
                this.filtered_list = results;
            } else {
                this.filter_people();
            }

            this.filtering = false;
        },
        set_active_group(slug) {
            // Clear the base values
            this.active_group.name = '';
            this.active_group.slug = '';
            this.active_group.term_id = '';
            this.sub_groups = [];
            this.selected = '';
            this.active_sub_group.name = '';
            this.active_sub_group.slug = '';
            this.active_sub_group.term_id = '';
            
            // Then loop through the groups
            for (var group in this.groups) {
                // If the slug passed across matches in the groups array
                if(this.groups[group].slug == slug) {
                    // Set the base values
                    this.active_group.name = this.groups[group].name;
                    this.active_group.slug = this.groups[group].slug;
                    this.active_group.term_id = this.groups[group].term_id;
                    // Then check if it has children / sub group
                    if(this.groups[group].children.length > 0) {
                        // Loop though these
                        for (var j = 0; j < this.groups[group].children.length; j++) {
                            // And push them into the sub groups array
                            let obj = {
                                name: this.groups[group].children[j].name,
                                slug: this.groups[group].children[j].slug,
                                term_id: this.groups[group].children[j].term_id,
                            }
                            this.sub_groups.push(obj);
                        }
                    }
                }
            }
            // Now filter the people based on this
            this.filter_people();
        },
        set_active_sub_group() {
            // Loop through the sub groups
            for (var i = 0; i < this.sub_groups.length; i++) {
                // If the slug passed across matches in the groups array
                if(this.sub_groups[i].slug == this.selected) {
                    // Set the base values
                    this.active_sub_group.name = this.sub_groups[i].name;
                    this.active_sub_group.slug = this.sub_groups[i].slug;
                    this.active_sub_group.term_id = this.sub_groups[i].term_id;
                }
            }
            // Now filter the people based on this
            this.filter_people();
        },
        set_inital_group() {
            // Lets set a group on load if none is in URL
            this.active_group.name = this.groups[0].name;
            this.active_group.slug = this.groups[0].slug;
            this.active_group.term_id = this.groups[0].term_id;

            if(this.groups[0].children.length > 0) {
                // Loop though these
                for (var j = 0; j < this.groups[0].children.length; j++) {
                    // And push them into the sub groups array
                    let obj = {
                        name: this.groups[0].children[j].name,
                        slug: this.groups[0].children[j].slug,
                        term_id: this.groups[0].children[j].term_id,
                    }
                    this.sub_groups.push(obj);
                }
            }
            
            // Now filter the people based on this
            this.filter_people();
        }
    },
    created() {
        // These two function resolve the &amp; issue we were having
        this.clean_groups();
        this.clean_profiles();
        // Now we can run as normal
        this.order_data();
        this.check_for_group_parameter_in_url();
    },
    beforeDestroy() {
        localStorage.removeItem('peopleArray' + this.panel_number);
    }
}
</script>
